module.exports = __webpack_public_path__ + "static/media/ST8.fae8d808.mp3";